<template>
	<div class="profile-wrapper">
		<div class="title">认证</div>
		<div class="renzheng">
			<div class="item">
				<div>
					<div class="item-name">
						<div class="icon"><i class="iconfont icon-icon_commone_shimingrenzhengmian"></i></div>
						<div class="sub-title">实名认证</div>
						<div><el-button type="text" style="color: #FF842E;" @click="$router.push({path:'/personal/certification'})">立即认证</el-button></div>
					</div>
					<div class="tips">完成实名认证即可发布话题水贴</div>
				</div>
			</div>
			<div class="item">
				<div>
					<div class="item-name">
						<div class="icon"><i class="iconfont icon-qiye2"></i></div>
						<div class="sub-title">企业认证</div>
						<div><el-button type="text" style="color: #FF842E;" @click="$router.push({path:'/personal/corporate'})">立即认证</el-button></div>
					</div>
					<div class="tips">完成企业认证获取专属企业标识</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import EventBus from '@/utils/eventHub.js'
import { getIsTrial, getToken } from '@/utils/auth'
export default {
  data () {
    return {
      url:'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
    }
  },
  methods: {
    
  },
  mounted () {
	  
  }

}
</script>

<style lang="scss" scoped>
.profile-wrapper{
	padding: 30px 40px;
	.title{
		font-size: 20px;
		font-weight: 800;
	}
	.renzheng{
		display: flex;
		.item{
			flex: 1;
			border: 1px solid #E8E8E9;
			border-radius: 5px;
			margin: 30px 30px;
			margin-left: 0;
			&:last-child{
				margin-right: 0;
			}
			&>div{
				background-color: rgba(249, 249, 249, 0.8);
				border-radius: 5px;
				margin: 5px;
				padding: 20px;
				.item-name>div{
					display: inline-block;
					&.icon{
						background-color: #FF842E;
						width: 28px;
						height:28px;
						border-radius: 50%;
						color: #fff;
						display: inline-flex;
						justify-content: center;
						align-items: center;
						margin-right: 10px;
						.iconfont{
							font-size: 18px;
						}
					}
					&:last-child{
						float: right;
						margin-top: -5px;
					}
				}
				
				.sub-title{
					font-size: 18px;
					font-weight: 800;
				}
			}
			.tips{
				font-size: 14px;
				color: #959596;
				margin-top: 15px;
			}
		}
	}
}	

</style>